import { Icon, IconProps } from '@chakra-ui/react';
import { ArrowBackIcon, ArrowDownIcon, ArrowUpIcon, SearchIcon, InfoIcon } from '@chakra-ui/icons';
import { ChevronRight } from 'react-feather';
import {
    MdArrowDropDown,
    MdArrowDropUp,
    MdClear,
    MdFileUpload,
    MdFilterList,
    MdListAlt,
    MdOutlineArrowForward,
    MdOutlineFileDownload,
    MdOutlineFilePresent,
    MdOutlinePhoto,
    MdOutlineSort,
    MdOutlineWarning,
    MdSync,
    MdVpnKey,
    MdOutlineCheck,
    MdDeleteOutline,
    MdOutlinePendingActions,
    MdDeleteSweep,
    MdSettings,
} from 'react-icons/md';
import { SiMicrosoftexcel } from 'react-icons/si';
import { RiLayoutColumnLine, RiPencilFill } from 'react-icons/ri';
import { HiOutlinePlusSm } from 'react-icons/hi';
import { FaRegFileAlt, FaArchive } from 'react-icons/fa';
import { GiRank1 } from 'react-icons/gi';

const ListManagmentPageIcon = (props: any) => <Icon viewBox='"0 0 24 22' {...props} as={FaRegFileAlt} />;

const SideBarOpenIcon = (props: IconProps) => (
    <Icon {...props} fill={'transparent'}>
        <g clip-path="url(#clip0_973_1081)">
            <path
                d="M2.75 0.75H21.25C21.25 0.75 23.25 0.75 23.25 2.75V21.25C23.25 21.25 23.25 23.25 21.25 23.25H2.75C2.75 23.25 0.75 23.25 0.75 21.25V2.75C0.75 2.75 0.75 0.75 2.75 0.75Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
            <path
                d="M17.25 0.75V23.25"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.55469 16.4443L11.9991 11.9999L7.55469 7.55545"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_973_1081">
                <rect width="24" height="24" />
            </clipPath>
        </defs>
    </Icon>
);

const ProductPageIcon = (props: any) => (
    <Icon viewBox='"0 0 24 22' {...props}>
        <path
            d="M19.25 8H4.75C4.33579 8 4 8.33579 4 8.75V10.75C4 11.1642 4.33579 11.5 4.75 11.5H19.25C19.6642 11.5 20 11.1642 20 10.75V8.75C20 8.33579 19.6642 8 19.25 8Z"
            stroke="white"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M8.25 14.5H4.75C4.33579 14.5 4 14.8358 4 15.25V17.25C4 17.6642 4.33579 18 4.75 18H8.25C8.66421 18 9 17.6642 9 17.25V15.25C9 14.8358 8.66421 14.5 8.25 14.5Z"
            stroke="white"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M12 14.5H20" stroke="white" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12 18H20" stroke="white" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M21.75 1H2.25C1.42157 1 0.75 1.67157 0.75 2.5V19.5C0.75 20.3284 1.42157 21 2.25 21H21.75C22.5784 21 23.25 20.3284 23.25 19.5V2.5C23.25 1.67157 22.5784 1 21.75 1Z"
            stroke="white"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M0.75 5.5H23.25" stroke="white" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </Icon>
);

const SectorisationPageIcon = (props: any) => (
    <Icon fviewBox='"0 0 24 22' {...props}>
        <path
            d="M12 0.75H16.5V3.75H12z"
            fill="none"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.5"
        />
        <path
            d="M12 3.75L12 6.75"
            fill="none"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.5"
        />
        <path
            d="M9.25,17.25h5.5a1,1,0,0,1,1,1v5a0,0,0,0,1,0,0H8.25a0,0,0,0,1,0,0v-5a1,1,0,0,1,1-1Z"
            fill="none"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.5"
        />
        <path
            d="M12 17.25L12 23.25"
            fill="none"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.5"
        />
        <path
            d="M2.25 13.5L3.75 13.5"
            fill="none"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.5"
        />
        <path
            d="M20.25 13.5L21.75 13.5"
            fill="none"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.5"
        />
        <path
            d="M3 10.5L3.75 13.5 20.25 13.5 21 10.5"
            fill="none"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.5"
        />
        <path
            d="M21.75,10.5H16.424a4.485,4.485,0,0,0-8.848,0H2.25"
            fill="none"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.5"
        />
        <path
            d="M3.75 13.5H20.25V23.25H3.75z"
            fill="none"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.5"
        />
        <path
            d="M0.75 23.25L23.25 23.25"
            fill="none"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.5"
        />
    </Icon>
);

const ProductPageIcon2 = (props: any) => (
    <Icon fill="none" viewBox="0 0 48 48" {...props}>
        <g transform="matrix(2,0,0,2,0,0)">
            <line
                x1="8.75"
                y1="6.5"
                x2="8.75"
                y2="22"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5p"
            ></line>
            <line
                x1="4"
                y1="10.75"
                x2="5.5"
                y2="10.75"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5px"
            ></line>
            <line
                x1="4"
                y1="14.25"
                x2="5.5"
                y2="14.25"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5px"
            ></line>
            <line
                x1="4"
                y1="17.75"
                x2="5.5"
                y2="17.75"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5px"
            ></line>
            <rect
                x="12"
                y="10"
                width="8"
                height="8.5"
                rx="0.75"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5px"
            ></rect>
            <line
                x1="12"
                y1="14"
                x2="20"
                y2="14"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5px"
            ></line>
            <line
                x1="16"
                y1="14"
                x2="16"
                y2="18.5"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5px"
            ></line>
            <g>
                <rect
                    x="0.75"
                    y="2"
                    width="22.5"
                    height="20"
                    rx="1.5"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5px"
                ></rect>
                <line
                    x1="0.75"
                    y1="6.5"
                    x2="23.25"
                    y2="6.5"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5px"
                ></line>
            </g>
        </g>
    </Icon>
);

const DILogo = (props: any) => (
    <Icon viewBox="0 0 48 48" {...props}>
        <path
            d="M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z"
            fill="white"
        />
        <path
            d="M20.8608 23.9835C20.2279 23.9835 19.6093 23.7958 19.083 23.4442C18.5568 23.0926 18.1467 22.5928 17.9045 22.0081C17.6623 21.4234 17.5989 20.78 17.7224 20.1592C17.8459 19.5385 18.1506 18.9683 18.5982 18.5208C19.0457 18.0732 19.6159 17.7685 20.2366 17.645C20.8573 17.5215 21.5008 17.5849 22.0855 17.8271C22.6702 18.0693 23.17 18.4794 23.5216 19.0056C23.8732 19.5319 24.0609 20.1506 24.0609 20.7835C24.06 21.6319 23.7225 22.4453 23.1226 23.0452C22.5227 23.6451 21.7093 23.9826 20.8608 23.9835ZM20.8608 18.8435C20.4772 18.8436 20.1021 18.9574 19.7831 19.1705C19.464 19.3837 19.2154 19.6867 19.0686 20.0412C18.9218 20.3957 18.8834 20.7857 18.9582 21.1621C19.0331 21.5384 19.2179 21.884 19.4892 22.1553C19.7605 22.4266 20.1062 22.6114 20.4825 22.6862C20.8588 22.7611 21.2489 22.7226 21.6034 22.5758C21.9578 22.429 22.2608 22.1803 22.474 21.8613C22.6871 21.5422 22.8009 21.1671 22.8009 20.7835C22.8003 20.2691 22.5957 19.776 22.232 19.4123C21.8683 19.0486 21.3752 18.8441 20.8608 18.8435Z"
            fill="#03468E"
        />
        <path
            d="M39.2205 20.2716C38.5876 20.2716 37.9689 20.0839 37.4426 19.7323C36.9164 19.3807 36.5063 18.8809 36.2641 18.2961C36.0219 17.7114 35.9585 17.068 36.082 16.4473C36.2055 15.8265 36.5103 15.2563 36.9578 14.8088C37.4054 14.3613 37.9756 14.0565 38.5963 13.9331C39.217 13.8096 39.8605 13.873 40.4452 14.1152C41.0299 14.3574 41.5297 14.7676 41.8813 15.2938C42.2329 15.8201 42.4206 16.4388 42.4206 17.0717C42.4196 17.9201 42.0821 18.7335 41.4822 19.3334C40.8823 19.9333 40.0689 20.2707 39.2205 20.2716ZM39.2205 15.1316C38.8368 15.1316 38.4617 15.2454 38.1427 15.4586C37.8237 15.6718 37.575 15.9748 37.4282 16.3292C37.2814 16.6837 37.243 17.0738 37.3178 17.4501C37.3927 17.8264 37.5775 18.1721 37.8488 18.4434C38.1201 18.7147 38.4657 18.8994 38.842 18.9743C39.2184 19.0492 39.6084 19.0107 39.9629 18.8639C40.3174 18.7171 40.6204 18.4685 40.8335 18.1494C41.0467 17.8304 41.1605 17.4554 41.1605 17.0717C41.1599 16.5573 40.9554 16.0642 40.5917 15.7005C40.2279 15.3368 39.7348 15.1322 39.2205 15.1316Z"
            fill="#03468E"
        />
        <path
            d="M31.8458 33.792C31.213 33.792 30.5943 33.6043 30.0681 33.2527C29.5419 32.901 29.1317 32.4013 28.8896 31.8166C28.6474 31.2319 28.584 30.5885 28.7075 29.9677C28.831 29.347 29.1357 28.7769 29.5832 28.3293C30.0308 27.8818 30.6009 27.5771 31.2216 27.4536C31.8424 27.3301 32.4858 27.3935 33.0705 27.6357C33.6552 27.8778 34.155 28.288 34.5066 28.8142C34.8582 29.3404 35.0459 29.959 35.0459 30.5919C35.045 31.4404 34.7075 32.2538 34.1076 32.8537C33.5077 33.4536 32.6943 33.7911 31.8458 33.792ZM31.8458 28.6521C31.4622 28.6522 31.0871 28.766 30.7681 28.9791C30.4491 29.1923 30.2005 29.4953 30.0537 29.8498C29.9069 30.2043 29.8685 30.5943 29.9433 30.9706C30.0182 31.3469 30.203 31.6926 30.4743 31.9639C30.7456 32.2351 31.0913 32.4199 31.4676 32.4947C31.8439 32.5695 32.234 32.5311 32.5884 32.3843C32.9429 32.2374 33.2459 31.9887 33.459 31.6697C33.6721 31.3507 33.7859 30.9756 33.7859 30.5919C33.7853 30.0776 33.5807 29.5845 33.217 29.2209C32.8533 28.8572 32.3602 28.6527 31.8458 28.6521V28.6521Z"
            fill="#03468E"
        />
        <path
            d="M10.4583 33.792C9.82538 33.792 9.2067 33.6043 8.68047 33.2527C8.15424 32.9011 7.7441 32.4014 7.5019 31.8167C7.2597 31.2319 7.19632 30.5885 7.31978 29.9678C7.44324 29.3471 7.74799 28.7769 8.1955 28.3294C8.64301 27.8819 9.21318 27.5771 9.83391 27.4536C10.4546 27.3301 11.098 27.3935 11.6827 27.6356C12.2675 27.8778 12.7672 28.2879 13.1189 28.8142C13.4705 29.3404 13.6582 29.959 13.6582 30.5919C13.6573 31.4403 13.3198 32.2537 12.7199 32.8537C12.12 33.4536 11.3067 33.791 10.4583 33.792ZM10.4583 28.6521C10.0746 28.6521 9.69951 28.7659 9.38049 28.9791C9.06147 29.1922 8.81283 29.4952 8.66601 29.8497C8.51918 30.2042 8.48077 30.5942 8.55564 30.9706C8.6305 31.3469 8.81527 31.6925 9.08658 31.9638C9.3579 32.2351 9.70357 32.4199 10.0799 32.4947C10.4562 32.5695 10.8463 32.5311 11.2007 32.3843C11.5552 32.2374 11.8582 31.9888 12.0713 31.6697C12.2844 31.3507 12.3982 30.9756 12.3982 30.5919C12.3976 30.0776 12.193 29.5846 11.8293 29.2209C11.4656 28.8573 10.9726 28.6527 10.4583 28.6521V28.6521Z"
            fill="#03468E"
        />
        <path
            d="M13.8217 27.8943C13.6944 27.8943 13.5701 27.8558 13.4651 27.7838C13.3602 27.7119 13.2795 27.6098 13.2337 27.4911C13.1878 27.3723 13.179 27.2425 13.2085 27.1187C13.2379 26.9948 13.3041 26.8828 13.3984 26.7974L16.8622 23.6593C16.986 23.5473 17.1493 23.4891 17.316 23.4974C17.4828 23.5057 17.6395 23.5798 17.7516 23.7036C17.8637 23.8273 17.9221 23.9905 17.914 24.1573C17.9059 24.324 17.8319 24.4808 17.7083 24.593L14.2445 27.7311C14.1288 27.8362 13.978 27.8944 13.8217 27.8943Z"
            fill="#03468E"
        />
        <path
            d="M28.1238 27.7822C27.9597 27.7824 27.802 27.7184 27.6845 27.6038L24.4441 24.4515C24.3244 24.3349 24.256 24.1756 24.2537 24.0086C24.2515 23.8416 24.3156 23.6806 24.4321 23.5608C24.5485 23.4411 24.7078 23.3725 24.8748 23.3702C25.0418 23.3678 25.2029 23.4319 25.3227 23.5482L28.5631 26.7006C28.653 26.788 28.7147 26.9002 28.7404 27.0229C28.7662 27.1456 28.7547 27.2731 28.7075 27.3893C28.6604 27.5054 28.5796 27.6048 28.4757 27.6748C28.3717 27.7448 28.2492 27.7822 28.1238 27.7822Z"
            fill="#03468E"
        />
        <path
            d="M34.146 27.0038C34.0367 27.0036 33.9294 26.9751 33.8345 26.921C33.7396 26.8669 33.6605 26.789 33.6047 26.695C33.549 26.6011 33.5187 26.4942 33.5167 26.385C33.5147 26.2758 33.5412 26.1679 33.5935 26.072L36.3667 20.9878C36.4469 20.8415 36.5819 20.733 36.742 20.686C36.9022 20.6391 37.0744 20.6577 37.2209 20.7376C37.3674 20.8175 37.4762 20.9522 37.5234 21.1123C37.5707 21.2723 37.5525 21.4446 37.4729 21.5912L34.6997 26.6755C34.6455 26.7749 34.5654 26.8579 34.4679 26.9157C34.3705 26.9735 34.2593 27.0039 34.146 27.0038Z"
            fill="#03468E"
        />
    </Icon>
);

const DILogoFilled = (props: any) => (
    <Icon viewBox="0 0 48 48" {...props}>
        <path
            d="M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z"
            fill="#FEBF00"
        />
        <path
            d="M20.8608 23.9835C20.2279 23.9835 19.6093 23.7958 19.083 23.4442C18.5568 23.0926 18.1467 22.5928 17.9045 22.0081C17.6623 21.4234 17.5989 20.78 17.7224 20.1592C17.8459 19.5385 18.1506 18.9683 18.5982 18.5208C19.0457 18.0732 19.6159 17.7685 20.2366 17.645C20.8573 17.5215 21.5008 17.5849 22.0855 17.8271C22.6702 18.0693 23.17 18.4794 23.5216 19.0056C23.8732 19.5319 24.0609 20.1506 24.0609 20.7835C24.06 21.6319 23.7225 22.4453 23.1226 23.0452C22.5227 23.6451 21.7093 23.9826 20.8608 23.9835ZM20.8608 18.8435C20.4772 18.8436 20.1021 18.9574 19.7831 19.1705C19.464 19.3837 19.2154 19.6867 19.0686 20.0412C18.9218 20.3957 18.8834 20.7857 18.9582 21.1621C19.0331 21.5384 19.2179 21.884 19.4892 22.1553C19.7605 22.4266 20.1062 22.6114 20.4825 22.6862C20.8588 22.7611 21.2489 22.7226 21.6034 22.5758C21.9578 22.429 22.2608 22.1803 22.474 21.8613C22.6871 21.5422 22.8009 21.1671 22.8009 20.7835C22.8003 20.2691 22.5957 19.776 22.232 19.4123C21.8683 19.0486 21.3752 18.8441 20.8608 18.8435Z"
            fill="white"
        />
        <path
            d="M39.2205 20.2716C38.5876 20.2716 37.9689 20.0839 37.4426 19.7323C36.9164 19.3807 36.5063 18.8809 36.2641 18.2961C36.0219 17.7114 35.9585 17.068 36.082 16.4473C36.2055 15.8265 36.5103 15.2563 36.9578 14.8088C37.4054 14.3613 37.9756 14.0565 38.5963 13.9331C39.217 13.8096 39.8605 13.873 40.4452 14.1152C41.0299 14.3574 41.5297 14.7676 41.8813 15.2938C42.2329 15.8201 42.4206 16.4388 42.4206 17.0717C42.4196 17.9201 42.0821 18.7335 41.4822 19.3334C40.8823 19.9333 40.0689 20.2707 39.2205 20.2716ZM39.2205 15.1316C38.8368 15.1316 38.4617 15.2454 38.1427 15.4586C37.8237 15.6718 37.575 15.9748 37.4282 16.3292C37.2814 16.6837 37.243 17.0738 37.3178 17.4501C37.3927 17.8264 37.5775 18.1721 37.8488 18.4434C38.1201 18.7147 38.4657 18.8994 38.842 18.9743C39.2184 19.0492 39.6084 19.0107 39.9629 18.8639C40.3174 18.7171 40.6204 18.4685 40.8335 18.1494C41.0467 17.8304 41.1605 17.4554 41.1605 17.0717C41.1599 16.5573 40.9554 16.0642 40.5917 15.7005C40.2279 15.3368 39.7348 15.1322 39.2205 15.1316Z"
            fill="white"
        />
        <path
            d="M31.8458 33.792C31.213 33.792 30.5943 33.6043 30.0681 33.2527C29.5419 32.901 29.1317 32.4013 28.8896 31.8166C28.6474 31.2319 28.584 30.5885 28.7075 29.9677C28.831 29.347 29.1357 28.7769 29.5832 28.3293C30.0308 27.8818 30.6009 27.5771 31.2216 27.4536C31.8424 27.3301 32.4858 27.3935 33.0705 27.6357C33.6552 27.8778 34.155 28.288 34.5066 28.8142C34.8582 29.3404 35.0459 29.959 35.0459 30.5919C35.045 31.4404 34.7075 32.2538 34.1076 32.8537C33.5077 33.4536 32.6943 33.7911 31.8458 33.792ZM31.8458 28.6521C31.4622 28.6522 31.0871 28.766 30.7681 28.9791C30.4491 29.1923 30.2005 29.4953 30.0537 29.8498C29.9069 30.2043 29.8685 30.5943 29.9433 30.9706C30.0182 31.3469 30.203 31.6926 30.4743 31.9639C30.7456 32.2351 31.0913 32.4199 31.4676 32.4947C31.8439 32.5695 32.234 32.5311 32.5884 32.3843C32.9429 32.2374 33.2459 31.9887 33.459 31.6697C33.6721 31.3507 33.7859 30.9756 33.7859 30.5919C33.7853 30.0776 33.5807 29.5845 33.217 29.2209C32.8533 28.8572 32.3602 28.6527 31.8458 28.6521V28.6521Z"
            fill="white"
        />
        <path
            d="M10.4583 33.792C9.82538 33.792 9.2067 33.6043 8.68047 33.2527C8.15424 32.9011 7.7441 32.4014 7.5019 31.8167C7.2597 31.2319 7.19632 30.5885 7.31978 29.9678C7.44324 29.3471 7.74799 28.7769 8.1955 28.3294C8.64301 27.8819 9.21318 27.5771 9.83391 27.4536C10.4546 27.3301 11.098 27.3935 11.6827 27.6356C12.2675 27.8778 12.7672 28.2879 13.1189 28.8142C13.4705 29.3404 13.6582 29.959 13.6582 30.5919C13.6573 31.4403 13.3198 32.2537 12.7199 32.8537C12.12 33.4536 11.3067 33.791 10.4583 33.792ZM10.4583 28.6521C10.0746 28.6521 9.69951 28.7659 9.38049 28.9791C9.06147 29.1922 8.81283 29.4952 8.66601 29.8497C8.51918 30.2042 8.48077 30.5942 8.55564 30.9706C8.6305 31.3469 8.81527 31.6925 9.08658 31.9638C9.3579 32.2351 9.70357 32.4199 10.0799 32.4947C10.4562 32.5695 10.8463 32.5311 11.2007 32.3843C11.5552 32.2374 11.8582 31.9888 12.0713 31.6697C12.2844 31.3507 12.3982 30.9756 12.3982 30.5919C12.3976 30.0776 12.193 29.5846 11.8293 29.2209C11.4656 28.8573 10.9726 28.6527 10.4583 28.6521V28.6521Z"
            fill="white"
        />
        <path
            d="M13.8217 27.8943C13.6944 27.8943 13.5701 27.8558 13.4651 27.7838C13.3602 27.7119 13.2795 27.6098 13.2337 27.4911C13.1878 27.3723 13.179 27.2425 13.2085 27.1187C13.2379 26.9948 13.3041 26.8828 13.3984 26.7974L16.8622 23.6593C16.986 23.5473 17.1493 23.4891 17.316 23.4974C17.4828 23.5057 17.6395 23.5798 17.7516 23.7036C17.8637 23.8273 17.9221 23.9905 17.914 24.1573C17.9059 24.324 17.8319 24.4808 17.7083 24.593L14.2445 27.7311C14.1288 27.8362 13.978 27.8944 13.8217 27.8943Z"
            fill="white"
        />
        <path
            d="M28.1238 27.7822C27.9597 27.7824 27.802 27.7184 27.6845 27.6038L24.4441 24.4515C24.3244 24.3349 24.256 24.1756 24.2537 24.0086C24.2515 23.8416 24.3156 23.6806 24.4321 23.5608C24.5485 23.4411 24.7078 23.3725 24.8748 23.3702C25.0418 23.3678 25.2029 23.4319 25.3227 23.5482L28.5631 26.7006C28.653 26.788 28.7147 26.9002 28.7404 27.0229C28.7662 27.1456 28.7547 27.2731 28.7075 27.3893C28.6604 27.5054 28.5796 27.6048 28.4757 27.6748C28.3717 27.7448 28.2492 27.7822 28.1238 27.7822Z"
            fill="white"
        />
        <path
            d="M34.146 27.0038C34.0367 27.0036 33.9294 26.9751 33.8345 26.921C33.7396 26.8669 33.6605 26.789 33.6047 26.695C33.549 26.6011 33.5187 26.4942 33.5167 26.385C33.5147 26.2758 33.5412 26.1679 33.5935 26.072L36.3667 20.9878C36.4469 20.8415 36.5819 20.733 36.742 20.686C36.9022 20.6391 37.0744 20.6577 37.2209 20.7376C37.3674 20.8175 37.4762 20.9522 37.5234 21.1123C37.5707 21.2723 37.5525 21.4446 37.4729 21.5912L34.6997 26.6755C34.6455 26.7749 34.5654 26.8579 34.4679 26.9157C34.3705 26.9735 34.2593 27.0039 34.146 27.0038Z"
            fill="white"
        />
    </Icon>
);

const KeywordsIcon = (props: any) => (
    <Icon fill="none" viewBox="0 0 48 48" {...props}>
        <g transform="matrix(2,0,0,2,0,0)">
            <path
                d="M15.750 4.625 A3.125 3.125 0 1 0 22.000 4.625 A3.125 3.125 0 1 0 15.750 4.625 Z"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
            ></path>
            <path
                d="M21.085 6.834L23.25 9"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
            ></path>
            <path
                d="M12.75,7.5H2.25A1.5,1.5,0,0,1,.75,6V4.5A1.5,1.5,0,0,1,2.25,3h10.5"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
            ></path>
            <path
                d="M2.625,11.25a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
            ></path>
            <path
                d="M6 12L18 12"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
            ></path>
            <path
                d="M2.625,16.5a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
            ></path>
            <path
                d="M6 17.25L18 17.25"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
            ></path>
            <path
                d="M2.625,21.75a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
            ></path>
            <path
                d="M6 22.5L18 22.5"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
            ></path>
        </g>
    </Icon>
);

const UsersIcon = (props: any) => (
    <Icon fill="none" viewBox="0 0 48 48" {...props}>
        <g transform="matrix(2,0,0,2,0,0)">
            <path
                d="M23.25,18.75v3a1.5,1.5,0,0,1-1.5,1.5h-3"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
            ></path>
            <path
                d="M18.75.75h3a1.5,1.5,0,0,1,1.5,1.5v3"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
            ></path>
            <path
                d="M.75,5.25v-3A1.5,1.5,0,0,1,2.25.75h3"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
            ></path>
            <path
                d="M5.25,23.25h-3a1.5,1.5,0,0,1-1.5-1.5v-3"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
            ></path>
            <path
                d="M7.875 9.000 A4.125 4.125 0 1 0 16.125 9.000 A4.125 4.125 0 1 0 7.875 9.000 Z"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
            ></path>
            <path
                d="M18.365,19.125a6.751,6.751,0,0,0-12.73,0"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
            ></path>
        </g>
    </Icon>
);

const HomeIcon = (props: any) => (
    <Icon fill="none" viewBox="0 0 24 24" {...props}>
        <path
            d="M0.75 12.47L10.86 2.35001C11.009 2.20012 11.1868 2.08206 11.3828 2.00298C11.5787 1.92391 11.7887 1.88547 12 1.89001C12.4238 1.89182 12.8299 2.06071 13.13 2.36001L23.25 12.47"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M20.04 9.26V22.11H3.95996V9.25"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M15.21 22.11V17.29C15.21 16.4386 14.8718 15.6222 14.2699 15.0202C13.6679 14.4182 12.8514 14.08 12 14.08C11.1487 14.08 10.3322 14.4182 9.73023 15.0202C9.12823 15.6222 8.79004 16.4386 8.79004 17.29V22.11"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M12 10.73C13.1819 10.73 14.14 9.7719 14.14 8.59001C14.14 7.40812 13.1819 6.45001 12 6.45001C10.8181 6.45001 9.85999 7.40812 9.85999 8.59001C9.85999 9.7719 10.8181 10.73 12 10.73Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
);

const ImagesIcon = (props: any) => (
    <Icon fill="none" viewBox="0 0 24 24" strokeWidth="1.5" {...props}>
        <path
            d="M22.477,21.75a1.5,1.5,0,0,1-1.5,1.5H3.023a1.5,1.5,0,0,1-1.5-1.5V2.25a1.5,1.5,0,0,1,1.5-1.5h15a1.5,1.5,0,0,1,1.047.426l2.955,2.883a1.5,1.5,0,0,1,.452,1.074Z"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        ></path>
        <path
            d="M6.023 7.500 A2.250 2.250 0 1 0 10.523 7.500 A2.250 2.250 0 1 0 6.023 7.500 Z"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        ></path>
        <path
            d="M18.813,18.2l-3.925-5.888a1.011,1.011,0,0,0-1.671-.019l-2.691,3.845L8.858,14.8a1.011,1.011,0,0,0-1.474.229L5.273,18.2"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        ></path>
    </Icon>
);

const HistoryIcon = (props: any) => (
    <Icon viewBox="0 0 48 48" {...props}>
        <g transform="matrix(2,0,0,2,0,0)">
            <rect
                fill="none"
                stroke="currentColor"
                strokeLinejoin="round"
                strokeWidth="1.5px"
                x="0.75"
                y="3.75"
                width="22.5"
                height="19.5"
                rx="1.5"
                ry="1.5"
            ></rect>
            <line
                fill="none"
                stroke="currentColor"
                strokeLinejoin="round"
                strokeWidth="1.5px"
                x1="0.75"
                y1="9.75"
                x2="23.25"
                y2="9.75"
            ></line>
            <line
                fill="none"
                stroke="currentColor"
                strokeLinejoin="round"
                strokeWidth="1.5px"
                strokeLinecap="round"
                x1="6.75"
                y1="6"
                x2="6.75"
                y2="0.75"
            ></line>
            <line
                fill="none"
                stroke="currentColor"
                strokeLinejoin="round"
                strokeWidth="1.5px"
                strokeLinecap="round"
                x1="17.25"
                y1="6"
                x2="17.25"
                y2="0.75"
            ></line>
            <polyline
                fill="none"
                stroke="currentColor"
                strokeLinejoin="round"
                strokeWidth="1.5px"
                strokeLinecap="round"
                points="11.344 15.75 9 15.75 9 12.75"
            ></polyline>
            <path
                fill="none"
                stroke="currentColor"
                strokeLinejoin="round"
                strokeWidth="1.5px"
                strokeLinecap="round"
                d="M9.118,15.75a3.925,3.925,0,0,1,3.632-3,3.75,3.75,0,1,1-2.931,6.089"
            ></path>
        </g>
    </Icon>
);

const GearIcon = (props: any) => {
    return (
        <Icon viewBox="0 0 50 50" {...props}>
            <MdSettings size="50px" />
        </Icon>
    );
};

const icons = {
    archive: FaArchive,
    arrowBack: ArrowBackIcon,
    arrowDown: ArrowDownIcon,
    arrowUp: ArrowUpIcon,
    arrowGo: MdOutlineArrowForward,
    column: RiLayoutColumnLine,
    clear: MdClear,
    check: MdOutlineCheck,
    chevronRight: ChevronRight,
    delete: MdDeleteOutline,
    deleteSweep: MdDeleteSweep,
    diLogo: DILogo,
    diLogoFilled: DILogoFilled,
    download: MdOutlineFileDownload,
    excel: SiMicrosoftexcel,
    files: MdOutlineFilePresent,
    filter: MdFilterList,
    home: HomeIcon,
    history: HistoryIcon,
    info: InfoIcon,
    image: ImagesIcon,
    keywords: KeywordsIcon,
    key: MdVpnKey,
    list: MdListAlt,
    secto: MdListAlt,
    listManagment: ListManagmentPageIcon,
    sectorisation: SectorisationPageIcon,
    pending: MdOutlinePendingActions,
    product: ProductPageIcon,
    productBis: ProductPageIcon2,
    plus: HiOutlinePlusSm,
    photo: MdOutlinePhoto,
    rank: GiRank1,
    sync: MdSync,
    search: SearchIcon,
    sortUp: MdArrowDropUp,
    sort: MdOutlineSort,
    sortDown: MdArrowDropDown,
    user: UsersIcon,
    update: RiPencilFill,
    upload: MdFileUpload,
    warning: MdOutlineWarning,
    preferences: GearIcon,
    sideBarOpen: SideBarOpenIcon,
} as const;

export type TIcon = keyof typeof icons;
export type TIconKeys = keyof typeof icons;

export default icons;
